import { render, staticRenderFns } from "./HowToStandardTh.vue?vue&type=template&id=0d339f11&scoped=true&"
import script from "./HowToStandardTh.vue?vue&type=script&lang=js&"
export * from "./HowToStandardTh.vue?vue&type=script&lang=js&"
import style0 from "./HowToStandardTh.vue?vue&type=style&index=0&id=0d339f11&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d339f11",
  null
  
)

export default component.exports